var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendUsMailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1663 12.5583V28.3333C37.1664 29.6087 36.6791 30.8359 35.8042 31.7638C34.9293 32.6917 33.7328 33.2502 32.4597 33.325L32.1663 33.3333H8.83301C7.55766 33.3334 6.33048 32.8461 5.40257 31.9712C4.47466 31.0963 3.91616 29.8998 3.84134 28.6267L3.83301 28.3333V12.5583L19.5747 23.0533L19.768 23.1633C19.9958 23.2747 20.2461 23.3325 20.4997 23.3325C20.7533 23.3325 21.0035 23.2747 21.2313 23.1633L21.4247 23.0533L37.1663 12.5583Z",
    fill: "#1E1E1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1659 6.66669C33.9659 6.66669 35.5442 7.61669 36.4242 9.04502L20.4992 19.6617L4.57422 9.04502C4.99221 8.36639 5.56637 7.79752 6.24884 7.38584C6.93131 6.97415 7.70231 6.73158 8.49755 6.67835L8.83255 6.66669H32.1659Z",
    fill: "#1E1E1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendUsMailIcon);
export default __webpack_public_path__ + "static/media/send-us-mail-icon.6652d8bfb76c05084251e3df9aafddf5.svg";
export { ForwardRef as ReactComponent };